import React from 'react';

function EngagementBar({
  commentCount = 0,
  onComment,
  onShare,
  onAddWisdom,
  onCreateTimeCapsule
}) {
  return (
    <div className="engagement-bar">
      <div className="engagement-left">
        <button className="engagement-btn" onClick={onComment}>
          <span className="engagement-emoji">💬</span>
          <span className="engagement-count">{commentCount}</span>
        </button>
        <button className="engagement-btn" onClick={onShare}>
          <span className="engagement-emoji">↗️</span>
        </button>
      </div>
      <div className="engagement-right">
        <button className="action-wisdom" onClick={onAddWisdom}>
          <span>💡</span>
          <span>Wisdom</span>
        </button>
        <button className="action-capsule" onClick={onCreateTimeCapsule}>
          <span>⏰</span>
          <span>Capsule</span>
        </button>
      </div>
    </div>
  );
}

export default EngagementBar;
